import { getMallList } from 'app/api/mall';
import { addNotification, getWhatsappCampaignList } from 'app/api/notification';
import { uplaodMedia } from 'app/api/store';
import { getDefaultTierByMallId } from 'app/api/tier';
import {
  notificationValidationRules,
  validate,
} from 'app/constants/validation-constants';
import Message from 'app/utils/Message';
import Toast from 'app/utils/Toast';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';

const useCreateNotification = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [pageLoading, setPageLoading] = useState(false);
  const [mallList, setMallList] = useState([]);
  const [tierMaster, settierMaster] = useState([]);
  const [campaignList, setCampaignList] = useState([]);

  const [error, setErrors] = useState({});
  const [values, setValues] = useState({
    mall_id_temp: '',
    name: '',
    tierId: '',
    title: '',
    message: '',
    gender_type: '',
    link: '',
    media: null,
    user_type: '',
    notification_type: '',
    campaign: '',
    sourcePayload: {
      mall_name: '',
      tier_Name: '',
    },
  });

  const notificationId = location?.state?.id ? location?.state?.id : '';

  useEffect(() => {
    getMallListforDropdown();
  }, [notificationId]);

  const getMallListforDropdown = async () => {
    setPageLoading(true);
    let response = await getMallList(1);
    setPageLoading(false);
    if (response && response?.responseCode === 200) {
      let temp = await response?.data?.malls?.map((item, index) => {
        return {
          ...item,
          value: item.id,
          label: item.name,
        };
      });
      temp.unshift({ value: 'All', label: 'All Mall' });
      setMallList([...temp]);
    } else {
      Toast.error(
        response?.data ? response?.data : Message?.Error?.COMMON_MESSAGE
      );
    }
  };
  const getTierTypes = async (id) => {
    setPageLoading(true);
    let response = await getDefaultTierByMallId(id);
    setPageLoading(false);
    if (response && response?.responseCode === 200) {
      let temp = await response?.data?.map((item, index) => {
        return {
          ...item,
          value: item.id,
          label: item.name,
        };
      });
      temp.unshift({ value: 'All', label: 'All Tier' });
      settierMaster([...temp]);
    } else {
      Toast.error(
        response?.data?.message
          ? response?.data?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  };
  const getCampaignListValues = async (id) => {
    setPageLoading(true);
    let response = await getWhatsappCampaignList();
    setPageLoading(false);
    if (response && response?.responseCode === 200) {
      let temp = await response?.data?.map((item, index) => {
        return {
          ...item,
          value: item?.templateId,
          label: item?.name,
        };
      });
      setCampaignList([...temp]);
    } else {
      Toast.error(
        response?.data?.message
          ? response?.data?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  };

  async function callAddOrUpdateAPI() {
    setPageLoading(true);
    let response = {};
    const fileExtension = values?.media?.split('.').pop().toLowerCase();
    const temp = {
      ...values,
      media_type: fileExtension
        ? fileExtension === 'mp4'
          ? 'video'
          : 'image'
        : null,
      gender: { gender: values.gender_type },
      mall_id: { mallId: values.mall_id_temp },
      tierType: { tierId: values.tierId },
      type: values.notification_type,
      campaign: values.campaign,
      sourcePayload: {
        tierName: values.tierName,
        mallName: values.mallName,
      },
    };
    delete temp.tierId;
    delete temp.tierName;
    delete temp.mallName;
    delete temp.mall_id_temp;
    delete temp.gender_type;
    delete temp.notification_type;

    response = await addNotification({ ...temp });

    setPageLoading(false);

    if (response?.responseCode === 200) {
      Toast.success(Message.Notifications.CREATED_SUCCESS);
      navigate(-1);
    } else {
      Toast.error(
        response?.response?.message
          ? response?.response?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  }
  function handleCreateNotification(e) {
    e.preventDefault();
    const validationErrors = validate(values, notificationValidationRules);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      callAddOrUpdateAPI();
    }
  }
  function handleNotificationtypeChange(e) {
    if (e && e.target) {
      const { name, value } = e.target;
      setCampaignList([]);

      if (value === 'whatsapp') {
        getCampaignListValues();
        setValues({
          ...values,
          [name]: value,
          campaign: '',
        });
        setErrors({
          ...error,
          [name]: '',
          campaign: '',
        });
        return;
      } else {
        setValues({
          ...values,
          [name]: value,
          campaign: '',
        });

        setErrors({
          ...error,
          [name]: '',
          campaign: '',
        });
      }
    }
  }
  function handleMallChange(e) {
    if (e && e.target) {
      const { name, value } = e.target;
      settierMaster([]);
      setCampaignList([]);

      const selectedMall = mallList.find((mall) => mall.id === value);
      const mallName = selectedMall ? selectedMall.name : '';

      if (value === 'All') {
        setValues({
          ...values,
          [name]: value,
          tierId: 'All',
          mallName: 'All',
        });

        setErrors({
          ...error,
          [name]: '',
          tierId: '',
          tierName: '',
          mallName: '',
        });

        return;
      } else {
        getTierTypes(value);
        setValues({
          ...values,
          [name]: value,
          tierId: null,
          mallName,
        });

        setErrors({
          ...error,
          [name]: '',
          tierId: '',
          tierName: '',
          mallName: '',
        });
      }
    }
  }
  function handleTierChange(e) {
    if (e && e.target) {
      const { name, value } = e.target;
      console.log('name', name, 'value', value);
      const selectedTier = tierMaster.find((tier) => tier.id === value);
      const tierName = selectedTier ? selectedTier.name : '';

      setValues({
        ...values,
        [name]: value,
        tierName: tierName,
      });

      if (error[name]) {
        setErrors({
          ...error,
          [name]: '',
        });
      }
    }
  }
  function handleChange(e) {
    if (e && e.target) {
      const { name, value } = e.target;
      console.log('name', name, 'value', value);
      setValues({
        ...values,
        [name]: value,
      });

      if (error[name]) {
        setErrors({
          ...error,
          [name]: '',
        });
      }
    }
  }
  function setChange(name, val) {
    setValues((prevState) => ({
      ...prevState,
      [name]: val,
    }));
    setErrors({
      ...error,
      [name]: '',
    });
  }

  const uploadMediaHandler = async (file, name) => {
    if (!file) {
      // If the file is null, it means the user clicked the remove button
      setChange(name, null);
      return;
    }

    const response = await uplaodMedia(file);
    if (response.responseCode === 200) {
      Toast.success('Image upload Successfull');

      const data = await response.data;
      setChange(name, data?.url);
    } else {
      Toast.error(
        response?.response?.message
          ? response?.response?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  };
  return {
    setChange,
    handleChange,
    values,
    error,
    handleCreateNotification,
    pageLoading,
    notificationId,
    mallList,
    tierMaster,
    navigate,
    uploadMediaHandler,
    handleMallChange,
    handleTierChange,
    campaignList,
    handleNotificationtypeChange,
  };
};

export default useCreateNotification;
